module.exports = __webpack_public_path__ + "img/fi-rr-arrow-small-left.e667906c.svg";